module.exports = __webpack_public_path__ + "static/media/logoTitan.7506a422.svg";